import ItineraryGroup from '~/models/ItineraryGroup'
import { BaseMemoryCache } from '../baseMemoryCache'

export class SpotTagsCache extends BaseMemoryCache<ItineraryGroup> {
	getTripTags(itineraryId: string): ItineraryGroup[] | undefined {
		const cached = this.get(`tags-${itineraryId}`)
		if (!Array.isArray(cached)) return
		return cached as ItineraryGroup[]
	}

	setTripTags(itineraryId: string, tags: ItineraryGroup[]): void {
		this.set(tags, `tags-${itineraryId}`)
	}

	deleteTripTags(itineraryId: string): void {
		this.delete(`tags-${itineraryId}`)
	}

	addTag(itineraryId: string, tag: ItineraryGroup): void {
		const cached = this.getTripTags(itineraryId)
		if (!cached) return
		this.setTripTags(itineraryId, [...cached, tag])
	}

	updateTag(itineraryId: string, tag: ItineraryGroup): void {
		const cached = this.getTripTags(itineraryId)
		if (!cached || !tag.id) return
		const updated = cached.map((current) => (current.id === tag.id ? tag : current))
		this.setTripTags(itineraryId, updated)
	}

	removeTag(itineraryId: string, tagId: string): void {
		const cached = this.getTripTags(itineraryId)
		if (!cached) return
		this.setTripTags(
			itineraryId,
			cached.filter((current) => current.id !== tagId)
		)
	}
}
